import React from 'react'

import { StyledTopicLabel } from '../../typography/TopicLabel/TopicLabel.styled'
import { toTopicRouteHint } from '@news-mono/web-common'
import { Topic } from '@news-mono/web-common'

export interface TopicLabelProps {
    text: string
    topic: Topic
    className?: string
}

export const TopicLabel: React.FC<TopicLabelProps> = (props) => (
    <StyledTopicLabel
        to={toTopicRouteHint(props.topic)}
        className={props.className}
    >
        {props.text}
    </StyledTopicLabel>
)
TopicLabel.displayName = 'TopicLabel'
